import styled, { css } from 'styled-components'
import { padding, PaddingProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { TRANSITION } from 'Constants/Animations'

type StyledButtonProps = {
  iconRotated?: boolean
}

const shouldForwardProp = (prop: string) =>
  ![...DIV_SHOULD_FORWARD_PROP, 'iconRotated'].includes(prop)

export const Container = styled.nav.withConfig({
  shouldForwardProp,
})<PaddingProps>`
  display: flex;
  align-items: center;

  ${padding}
`

export const NavButton = styled.button.withConfig({
  shouldForwardProp,
})<PaddingProps>`
  display: flex;

  ${padding}
`

const styledButtonIconRotatedCss = ({ iconRotated }: StyledButtonProps) =>
  iconRotated &&
  css`
    > svg {
      transform: rotateZ(180deg);
    }
  `

export const StyledButton = styled.button.withConfig({
  shouldForwardProp,
})<StyledButtonProps>`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.3')}px;
  padding: ${themeGet('space.6')}px;

  > svg {
    transition: all ${TRANSITION.DEFAULT.duration}s;
    transform: rotateZ(0deg);
  }

  ${styledButtonIconRotatedCss}
`

export const Dropdown = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${themeGet('space.7')}px;
  background-color: ${themeGet('colors.background.screen')};
  border-radius: 16px;
  box-shadow: ${themeGet('shadows.block')};
`
